module.exports = __webpack_public_path__ + "img/multi_warehouse_priority.136b4f36.png";